import { useMemo } from 'react';

import HTMLReactParser from 'html-react-parser';

const useDecodeString = str =>
  useMemo(() => {
    try {
      return HTMLReactParser(str || '');
    } catch (err) {
      console.trace('html parser err: ', err);
      return str;
    }
  }, [str]);

export default useDecodeString;
